<template>

  <div class="box box-primary" v-if="permissao" >
    <div class="box-header">
      <h2>Nova Notificação</h2>
    </div>
    <div class="box-body">

    <!-- <div class="conteudo" v-if="this.$store.state.login.loginUsuario.grupo.nome != 'fornecedor' && this.$store.state.login.loginUsuario.grupo.nome != 'usuario' && this.$store.state.login.loginUsuario.grupo.nome != 'fornecedor serviço' && this.$store.state.login.loginUsuario.grupo.nome != 'cgs'"> -->
    <div class="conteudo" v-if="this.$store.state.login.loginUsuario.grupo.nome != 'fornecedor' && this.$store.state.login.loginUsuario.grupo.nome != 'usuario' && this.$store.state.login.loginUsuario.grupo.nome != 'cgs'">
      <form>
        <div class="formulario">
          <fieldset>
            <legend>Selecione o estado:</legend>
            <select class="form-control" v-model="formNotificacao.uf_selecionada.valor">
                <option v-for="uf in ufs" :value='uf.id' >{{ uf.nome }}</option>
            </select>
          </fieldset>

          <fieldset>
            <legend>Selecione o contrato</legend>
            <select class="form-control" v-model="formNotificacao.tipo_imovel_servico.valor">
                <option v-for="i in tipo_imovel_servicos" :value='i.id' >{{ i.nome }}</option>
            </select>
          </fieldset>

          <fieldset>
            <legend>Selecione o mês de referência</legend>
            <select class="form-control" v-model="formNotificacao.mes_de_referencia.valor">
                <option v-for="mes in meses" :value='mes.id' >{{ mes.nome }}</option>
            </select>
          </fieldset>

          <fieldset>
            <legend>Selecione o ano de referência</legend>
            <select class="form-control" v-model="formNotificacao.ano_de_referencia.valor">
                <option v-for="i in anos" >{{ i.ano }}</option>
            </select>
          </fieldset>

          <fieldset>
            <legend>{{ formNotificacao.data_resposta_esperada.nome }}</legend>
            <div class="row">
              <div class='col-md-12'>
                <input
                  v-model="formNotificacao.data_resposta_esperada.valor"
                  class="form-control" type="date"
                >
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend>Insira o(s) email(s) para o comunicado de notificação <i>(Máximo 5 emails)</i></legend>
              <div
                class="div-email"
                v-for="(email, contador) in emails"
                v-bind:key="contador"
              >
                <input
                  type="email_envio"
                  class="form-control input-email"
                  id="email_envio"
                  v-model="email.email"
                  placeholder="Insira o email"
                >
                <button v-if="emails.length > 1" class="botao-remove-email" type="button" @click="removeEmail(contador)"><b-icon icon="trash-fill" aria-hidden="true"></b-icon></button>
                <br>
              </div>

              <button v-if="emails.length < 5" type="button" @click="addEmail">Adicionar mais um email</button>
          </fieldset>

          <fieldset>
            <legend>Insira uma descrição</legend>
            <div class="input-group textarea">
                <textarea id="descricao" v-model="formNotificacao.descricao.valor" :placeholder="formNotificacao.descricao.placeholder"></textarea>
            </div>
          </fieldset>

          <fieldset>
            <legend>Anexar arquivo</legend>
            <input type="file" ref="file_notificacoes" @change="configuraBotaoArquivo($event)">
          </fieldset>

          <div class="modal-footer" >
            <button
              v-on:click="salvarNotificao()"
              type="button" class="btn btn-primary pull-right" data-dismiss="modal"
              v-if="controlerBtnSubmit">Salvar
            </button>

            <button
              type="button"
              class="btn btn-primary btn-submit"
              disabled v-else><i class='fa fa-refresh fa-spin'></i> aguarde...
            </button>
          </div>

        </div>
      </form>
    </div>
    <div v-else>
      <h4>Seu grupo de usuário <b>{{this.$store.state.login.loginUsuario.grupo.nome}}</b>, não permite acesso a esta área.</h4>
    </div>
  </div>
</div>

</template>

<script>
  export default {
    data () {
      return {
        formNotificacao: {
          ano_de_referencia: {nome: 'ano_de_referencia', placeholder: 'Ano de referência', valor: ''},
          mes_de_referencia: {nome: 'mes_de_referencia', placeholder: 'Mês de referência', valor: ''},
          uf_selecionada: {nome: 'uf_selecionada', placeholder: 'UF', valor: ''},
          tipo_imovel_servico: {nome: 'tipo_imovel_servico', placeholder: 'Contrato selecionado', valor: ''},
          descricao: {nome: 'descricao', placeholder: 'Digite uma descrição', valor: ''},
          email_envio: {nome: 'email_envio', placeholder: 'Insira email', valor: ''},
          arquivo_de_notificacao: {nome: 'arquivo_de_notificacao', placeholder: 'Anexar arquivo', valor: '', tipo: 'arquivo', status: undefined},
          data_resposta_esperada: {nome: 'Data de resposta esperada', valor: ''}
        },
        env: process.env,
        meses: [],
        anos: [],
        ufs: [],
        gruposPermitidos: ['oi', 'admin'],
        permissao: true,
        tipo_imovel_servicos: '',
        controlerBtnSubmit: true,
        emails: [ { email: '' } ]
      }
    },
    mounted: function () {
      // Array com grupos do usuário
      let usuarioGrupo = this.$store.state.login.loginUsuario.grupo
      // msg(setPermissaoNegada) - função verificando se o usuário possui mais de um grupo(max 3)
      let msgGrupos = usuarioGrupo[0].nome
      if (usuarioGrupo[1]) {
        msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome
        if (usuarioGrupo[2]) {
          msgGrupos = usuarioGrupo[0].nome + ' ,' + usuarioGrupo[1].nome + ' ,' + usuarioGrupo[2].nome
        }
      }
      // console.log(msgGrupos)
      // if (usuarioGrupo.includes('admin') === true || usuarioGrupo.includes('oi') === true) {
      if (usuarioGrupo.find(permissao => permissao.nome === 'oi' || permissao.nome === 'admin')) {
        this.getAno()
        this.getMes()
        this.getUfsDoUsuario()
        this.getTipoImovelServico()
      } else {
        this.permissao = false
        this.$store.commit('setPermissaoNegada', {msg: `Seu grupo de usuáro [ ${msgGrupos} ] não permisse acesso a esta área.`, status: false, show: true})
      }
    },
    methods: {
      addEmail () {
        if (this.emails.length < 5) {
          this.emails.push({
            email: ''
          })
        }
      },
      removeEmail (counter) {
        this.emails.splice(counter, 1)
      },
      getAno () {
        let vm = this
        this.$axios.get(`${this.env.FINANCEIRO.SLA}/getano`, {
          headers: {
            'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
          }
        })
        .then(function (response) {
          vm.anos = response.data
        })
      },
      getUfsDoUsuario () {
        this.ufs = this.$store.state.login.loginUsuario.estado
      },
      getTipoImovelServico () {
        let vm = this
        this.$axios.get(`${this.env.FINANCEIRO.SLA}/gettipoimovelservico`, {
          headers: {
            'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
          }
        })
        .then(function (response) {
          vm.tipo_imovel_servicos = response.data
        })
      },
      configuraBotaoArquivo: function (event) {
        this.formNotificacao.arquivo_de_notificacao.valor = event.target.files[0]
      },
      salvarNotificao () {
        let vm = this
        if (!this.validacaoForm()) {
          this.$store.commit('setAlert', {msg: 'Preencha corretamente os campos.', status: false, show: true})
          return
        }
        this.controlerBtnSubmit = false

        this.$axios.post(`${this.env.FINANCEIRO.NOTIFICACAO}/notificacoes`, this.preencherFormData(), {
          headers: {
            'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (response) {
          let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
          document.getElementById('alertGlobal').style.zIndex = 99999
          if (response.status === 200 || response.status === 201) {
            vm.$store.commit('setAlert', {msg: `Notificação salva com sucesso.`, status: true, show: true})
          } else {
            vm.$store.commit('setAlert', {msg: `Notificação não foi salva.`, status: false, show: true})
          }
          vm.limparDadosFormulario()
          vm.controlerBtnSubmit = true
          vm.$store.commit('setRefreshComponente', refreshComponentes)
          vm.$router.push('/ListarNotificacoes')
        }).catch(error => {
          vm.$store.commit('setAlert', {msg: `${error.response.data.erro}`, status: false, show: true})
          vm.controlerBtnSubmit = true
        })
      },
      preencherFormData () {
        let email = JSON.stringify(this.emails)
        let formData = new FormData()
        formData.append('ano_de_referencia', this.formNotificacao.ano_de_referencia.valor)
        formData.append('mes_de_referencia', this.formNotificacao.mes_de_referencia.valor)
        formData.append('uf_selecionada', this.formNotificacao.uf_selecionada.valor)
        formData.append('tipo_imovel_servico', this.formNotificacao.tipo_imovel_servico.valor)
        formData.append('descricao', this.formNotificacao.descricao.valor)
        formData.append('email_envio', email)
        formData.append('data_resposta_esperada', this.formNotificacao.data_resposta_esperada.valor)
        formData.append('arquivo_de_notificacao', this.formNotificacao.arquivo_de_notificacao.valor)
        formData.append('name', this.$store.state.login.loginUsuario.usuario.name)
        formData.append('email', this.$store.state.login.loginUsuario.usuario.email)
        return formData
      },
      limparDadosFormulario () {
        this.formNotificacao.mes_de_referencia.valor = ''
        this.formNotificacao.ano_de_referencia.valor = ''
        this.formNotificacao.descricao.valor = ''
        this.emails = [ { email: '' } ]
        this.formNotificacao.tipo_imovel_servico.valor = ''
        this.formNotificacao.uf_selecionada.valor = ''
        this.formNotificacao.data_resposta_esperada.valor = ''
        this.formNotificacao.arquivo_de_notificacao.valor = ''
        this.$refs['file_notificacoes'].value = null
      },
      validacaoForm () {
        let validado = true
        if (this.formNotificacao.mes_de_referencia.valor === '' || this.formNotificacao.ano_de_referencia.valor === '' || this.formNotificacao.uf_selecionada.valor === '' || this.formNotificacao.tipo_imovel_servico.valor === '' || this.formNotificacao.descricao.valor === '') {
          validado = false
        }
        return validado
      },
      getMes () {
        let vm = this
        this.$axios.get(`${this.env.FINANCEIRO.SLA}/getmes`, {
          headers: {
            'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
          }
        }).then(function (response) {
          vm.meses = response.data
        })
      }
    }
  }
</script>
<style scoped src="./css/inserirNotificacao.css"></style>



// WEBPACK FOOTER //
// InserirNotificacao.vue?7e69c871